import styled from 'styled-components';
import { COLOR_WHITE, COLOR_LIGHT_PURPLE } from '../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';
import { rgba } from 'polished';
import { OptionsToggleSC } from './components/options-toggle/options-toggle.styled';
import { SmallTextSC } from '../typography/small-text';

export default styled.div`
  .toggle-wrapper {
    margin-bottom: 24px;
  }

  .card-subtext {
    margin-bottom: 24px;

    ${SmallTextSC} {
      color: ${rgba(COLOR_WHITE, 0.2)};
    }
  }

  .wrap {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .input-label {
    order: 2;
    position: relative;
    margin-bottom: 0px;
    font-size: 29px;
    padding-right: 20px;
    font-weight: bold;
    color: ${COLOR_WHITE};
  }
  .mid-wrap {
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    &--card {
      margin-bottom: 24px;
      margin-top: 24px;
      border-radius: 12px;
      background: ${COLOR_LIGHT_PURPLE};
      padding: 6px 8px 16px 16px;
      &.mb-0 {
        margin-bottom: 0;
      }
      &.mb-small {
        margin-bottom: 6px;
      }
      &.disabled {
        background: ${rgba(COLOR_LIGHT_PURPLE, 0.4)};
      }
      &__top {
        display: flex;
        justify-content: space-between;
        &.disabled {
          p {
            opacity: 0.4;
          }
        }
      }
      &__bottom {
        padding-top: 0;
        padding-right: 8px;
        overflow: hidden;

        &.padded {
          padding-top: 20px;
        }
        .wrap {
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .input-label {
          order: 2;
          position: relative;
          margin-bottom: 0px;
          font-size: 18px;
          padding-right: 20px;
          font-weight: bold;
          color: ${COLOR_WHITE};
        }

        .invest-amount-input {
          order: 1;
          font-size: 18px;
          font-weight: bold;
          padding-right: 8px;
          width: calc(100% - 20px);
          background: none;
          color: ${COLOR_WHITE};
          border: none;
          text-align: right;

          &.orange {
            color: #f0ac00;
          }
          &::placeholder {
            color: ${rgba(COLOR_WHITE, 0.2)};
          }
          &:active,
          &:focus {
            outline: none;
            box-shadow: none;
          }
        }
        &--stats {
          display: flex;
          justify-content: space-between;
        }
        &.disabled {
          pointer-events: none;
          opacity: 0.4;
        }
      }

      &.hoverable:hover {
        cursor: pointer;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        p {
          color: ${COLOR_WHITE};
        }
      }
    }

    .bid-wrap {
      padding-top: 16px;
    }
  }
  .submit-wrap {
    margin-top: 8px;
    button {
      padding: 7px 40px 7px 40px !important;
      font-size: 14px !important;
      text-transform: uppercase;
      min-width: 110px;
      border-radius: 8px;
    }
  }

  .years-switch {
    &--label {
      display: block;
      margin-top: 0;
      margin-bottom: 15px;
    }
    &__group {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    display: block;
    .submit-wrap button {
      width: 100%;
    }
  }

  ${OptionsToggleSC} {
    margin-top: 4px;
  }
`;
